import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '../vue_widgets/organization_location_select.vue'

export default class extends Controller {

  static values = { organizationId: String }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('multi select controller connected.')

    const props = {
      organizationId: this.organizationIdValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
